const getError = (error) => {
  const defaultError = {
    type: null,
    message: '문제가 발생했습니다. 잠시 후 다시 시도해주세요.',
  };

  if (!error) {
    return defaultError;
  }

  const { message, errors } = error;
  if (errors) {
    const errorParams = Object.keys(errors);
    if (errorParams.length) {
      return {
        type: errorParams[0],
        message: errors[errorParams[0]][0],
      };
    }
  }

  if (!message) {
    return defaultError;
  }

  return {
    type: null,
    message,
  };
};

const isBadRequest = (err) => err.statusCode === 400;

const isUnauthorized = (err) => err.statusCode === 401;

const isNotFound = (err) => err.statusCode === 404;

const isInternalServerError = (err) => err.statusCode === 500;

const EPISODE_RENTAL_ERROR = 'EpisodeRentalError';

const PAYMENT_ALREADY_PROCESSED_ERROR = 'PaymentAlreadyProcessedError';

const PAYMENT_INVALID_ERROR = 'PaymentInvalidError';

const PAYMENT_MODULATION_ERROR = 'PaymentModulationError';

const PAYMENT_CANCELED_BY_MODULATION_ERROR = 'PaymentCanceledByModulationError';

const COIN_SHORTAGE_ERROR = 'CoinShortageError';

const BANNED_USER_ERROR = 'BannedUserError';

const DUPLICATED_ERROR = 'DuplicatedError';

const SOCIAL_LOGIN_ERROR = 'SocialLoginError';
const FACEBOOK_LOGIN_ERROR = 'FacebookLoginError';
const KAKAO_LOGIN_ERROR = 'KakaoLoginError';
const NAVER_LOGIN_ERROR = 'NaverLoginError';
const GOOGLE_LOGIN_ERROR = 'GoogleLoginError';

const COUPON_ALREADY_USED_ERROR = 'CouponAlreadyUsedError';
const COUPON_EXPIRED_ERROR = 'CouponExpiredError';
const COUPON_INVALID_ERROR = 'CouponInvalidError';

const BALLOON_SHORTAGE_ERROR = 'PaidTapShortageError';
const ITEM_NOT_PURCHASABLE_ERROR = 'ItemNotPurchasableError';
const ITEM_ALREADY_PURCHASED_ERROR = 'ItemAlreadyPurchasedError';

const AUTHENTICATION_TOKEN_ERROR = 'AuthenticationTokenError';
const NOT_AUTHENTICATION = 'NotAuthenticated';

const EVENT_STAR_REWARD_INSUFFICIENT_ERROR = 'EventStarRewardInsufficientError';
const EVENT_STAR_ALREADY_OWNED_WITH_PROGRESS_ITEM_ERROR =
  'EventStarAlreadyOwnedWithProgressItemError';
const EVENT_STAR_ALREADY_OWNED_WITH_DONE_ITEM_ERROR =
  'EventStarAlreadyOwnedWithDoneItemError';
const USER_NOT_FOUND = 'UserNotFoundError';

const FB_USER_NOT_FOUND = 'auth/user-not-found';
const FB_USER_DISABLED = 'auth/user-disabled';
const FB_WRONG_PASSWORD = 'auth/wrong-password';

export default {
  getError,
  isBadRequest,
  isUnauthorized,
  isNotFound,
  isInternalServerError,
  EPISODE_RENTAL_ERROR,
  PAYMENT_ALREADY_PROCESSED_ERROR,
  PAYMENT_INVALID_ERROR,
  PAYMENT_MODULATION_ERROR,
  PAYMENT_CANCELED_BY_MODULATION_ERROR,
  COIN_SHORTAGE_ERROR,
  BANNED_USER_ERROR,
  DUPLICATED_ERROR,
  SOCIAL_LOGIN_ERROR,
  FACEBOOK_LOGIN_ERROR,
  KAKAO_LOGIN_ERROR,
  NAVER_LOGIN_ERROR,
  GOOGLE_LOGIN_ERROR,
  COUPON_ALREADY_USED_ERROR,
  COUPON_EXPIRED_ERROR,
  COUPON_INVALID_ERROR,
  BALLOON_SHORTAGE_ERROR,
  ITEM_NOT_PURCHASABLE_ERROR,
  ITEM_ALREADY_PURCHASED_ERROR,
  AUTHENTICATION_TOKEN_ERROR,
  NOT_AUTHENTICATION,
  EVENT_STAR_REWARD_INSUFFICIENT_ERROR,
  EVENT_STAR_ALREADY_OWNED_WITH_PROGRESS_ITEM_ERROR,
  EVENT_STAR_ALREADY_OWNED_WITH_DONE_ITEM_ERROR,
  USER_NOT_FOUND,
  FB_USER_NOT_FOUND,
  FB_USER_DISABLED,
  FB_WRONG_PASSWORD,
};



// WEBPACK FOOTER //
// ./src/app/utils/error.js